import { FlagIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { Tooltip } from '@/components/ui/tooltip'

import * as S from './next-lease-badge.styled'

export interface NextLeaseBadgeProps {
  tooltip: string
}

export const NextLeaseBadge = ({ tooltip }: NextLeaseBadgeProps) => (
  <Tooltip
    placement="bottom"
    trigger={
      <S.Circle tabIndex={0} role="img" aria-label={tooltip}>
        <Icon icon={FlagIcon} size="1.4rem" weight="fill" />
      </S.Circle>
    }
  >
    {tooltip}
  </Tooltip>
)
